import { useState, useEffect } from "react";
import { api } from "./apiClient";

let cachedNumber = null;
let inflight = null;

export function useWhatsApp() {
  const [number, setNumber] = useState(cachedNumber || "");

  useEffect(() => {
    if (cachedNumber) {
      setNumber(cachedNumber);
      return;
    }
    if (!inflight) {
      inflight = api
        .get("/config")
        .then((r) => {
          cachedNumber = r.data?.whatsapp_number || "";
          return cachedNumber;
        })
        .catch(() => "");
    }
    inflight.then((n) => n && setNumber(n));
  }, []);

  return number;
}
